import React from 'react';

function RevitIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "27",
    height: "32",
    viewBox: "0 0 27 32"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    fill: "#CBCBCB"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M25.271 6.545c.358.378.638.822.826 1.308.213.477.33.992.344 1.515V29.2a1.646 1.646 0 01-1.653 1.653H1.652A1.646 1.646 0 010 29.2V1.656A1.646 1.646 0 011.652 0h15.425c.523.014 1.038.13 1.515.344.486.188.93.468 1.308.826l5.371 5.375zm-7.642-4.2v6.473h6.473c-.074-.26-.203-.5-.379-.706L18.33 2.723a1.88 1.88 0 00-.706-.379l.006.001zm6.61 26.3V11.021h-7.162a1.646 1.646 0 01-1.653-1.653V2.207H2.204v26.442h22.034l.001-.004z"
  }), React.createElement("path", {
    d: "M1 15h24v11H1z"
  })), React.createElement("text", {
    fill: "#FFF",
    fontFamily: ".AppleSystemUIFont",
    fontSize: "10",
    letterSpacing: "0.556"
  }, React.createElement("tspan", {
    x: "3",
    y: "24"
  }, "RFA"))));
}

export default RevitIcon;